// Define common date formats
const DATEFORMAT = {
  dayMonthYear: 'DD-MMM-YYYY',
  yearMonthDay: 'YYYY-MM-DD',
  yearMonthDayWithTimezoneHoursMinutesSeconds: 'YYYY-MM-DDTHH:mm:ss',
  monthYearWithoutDash: 'MMMM YYYY',
  dayMonthDayWithHoursMinutesSecondsMeridiem: 'DD MMM YYYY hh:mm:ss A',
  dayMonthDayWithHoursMinutesSeconds: 'DD MMM YYYY HH:mm:ss',
  dayMonthYearWithoutDash: 'DD MMM YYYY',
  dayMonthYearWithDash: 'DD-MM-YYYY',
  yearMonthDayWithoutDash: 'YYYY MMM DD',
  year: 'YYYY',
  yearMonthDayWithZuluTime: 'YYYY-MM-DDTHH:mm:ss[Z]',
  dayMonthYearTwelveHoursTimeFormat: 'DD MMM YYYY, HH:mm:ss A',
  dayMonthYearWithNumber: 'DD-MMM-YY',
  onlyMonth: 'MMMM',
  dayDateMonthYearWithHoursMinutesSecondsMeridiem: 'ddd DD-MMM-YY HH:mm:ss A',
  monthYear: 'MMMM-YYYY',
  onlyDayMonth: 'DD MMM',
  dayMonthYearWithSingle: 'DD MMM YY',
  onlyMMM: 'MMM',
  onlyMMMYYYY: 'MMM-YYYY',
  onlyddDDMMMYY: 'ddd, DD MMM YY',
  onlyddDDMMMYYYY: 'ddd, DD MMM YYYY',
  onlyddDDMMMYYWithDash: 'ddd, DD-MMM-YYYY',
  onlyDayMonthYearWithSlash: 'DD/MMM/YYYY',
  onlyDDMMYYYHourMinutes: 'DD/MM/YYYY HH:mm',
  onlySingleMonth: 'M',
  onlyYearMonthDayTFormat: 'YYYY-MM-DD[T]00:00:00',
  onlyTimezoneYYYYMMDDD: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
};

export default DATEFORMAT;
